import {
  AutomationsPresentationV1Edge,
  AutomationsPresentationV1Node
} from 'Automations/automationEditor/types'

/**
 * Drop edges whose source or target node is absent. An orphan still counts as
 * an outgoing branch, so its source reads as a parallel fork.
 *
 *   nodes:  START, SWITCH            (X was deleted)
 *   edges:  START -> X       <- orphan: START looks like a 2-way fork
 *           START -> SWITCH
 */
export const pruneOrphanedEdges = ({
  nodes,
  edges
}: {
  nodes: AutomationsPresentationV1Node[]
  edges: AutomationsPresentationV1Edge[]
}): AutomationsPresentationV1Edge[] => {
  const nodeIds = new Set(nodes.map(node => node.id))

  return edges.filter(
    edge => nodeIds.has(edge.source) && nodeIds.has(edge.target)
  )
}
